import jwtDecode from 'jwt-decode';
import { CacheService } from './cache-service';

type Tokens = {
  access_token: string;
};

type AccessToken = {
  exp: number;
};

// todo revert
// const oneMinute = 60000;

const expirationKey = 'user.expiration';
const accessTokenKey = 'user.accessToken';

class AuthService {
  async logIn(formData: { email: string; password: string }): Promise<void> {
    const result = await fetch(`${process.env.REACT_APP_API!}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: formData.email, password: formData.password }),
    });
    const tokens = (await result.json()) as Tokens;
    this.setTokens(tokens);
  }

  logOut(): void {
    this.deleteTokens();
  }

  isAuthed(): boolean {
    return this.isValidToken();
  }

  getAccessToken(): string {
    return CacheService.get(accessTokenKey);
  }

  isValidToken(): boolean {
    const exp = CacheService.get(expirationKey);
    if (!exp) {
      return false;
    }
    return parseInt(exp, 10) > Date.now();
  }

  private setTokens(tokens: Tokens): void {
    const decodedToken: AccessToken = jwtDecode(tokens.access_token);
    CacheService.set(expirationKey, `${decodedToken.exp * 1000}`);
    CacheService.set(accessTokenKey, tokens.access_token);
  }

  private deleteTokens(): void {
    CacheService.delete(expirationKey);
    CacheService.delete(accessTokenKey);
  }
}

const authService = new AuthService();

export default authService;
